module.exports = __webpack_public_path__ + "static/favicon-a693d595119b991d716a6299b4f388a5.png";